export enum TicketStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_OTHERS = 'WAITING_FOR_OTHERS',
  CANCELLED = 'CANCELLED',
  UNEXPECTED = 'UNEXPECTED',
}
